//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MembershipPlanCurrencyCode } from './Enums';

export class MembershipPlanDisplayItem extends ItemBase {
    Active: boolean = false;
    Currency: MembershipPlanCurrencyCode = MembershipPlanCurrencyCode.AUD;
    CurrencySymbol: string | null = null;
    StripeCurrencyMultiplier: number = 0;
    ID: string | null = null;
    IsForNonProfit: boolean = false;
    NumberOfMonthsBetweenRecurrence: number = 0;
    NumberOfTeachers: number = 0;
    Price: number = 0;
    Title: string | null = null;

    constructor(initializer?: Partial<MembershipPlanDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipPlanDisplayItem";
}
